module.exports = __webpack_public_path__ + "static/media/emily-addison-win.0ab0532e.jpg";